import { Component, computed, inject, input, OnInit } from '@angular/core';

import { IncidentsCriteriaStore, type IncidentsFilterCriteria, type IncidentsScope } from '../../../state/incidents-criteria.store';
import { IncidentsV2TableComponent } from '../incidents-v2-table/incidents-v2-table.component';
import { IncidentsV2TableDesktopFiltersComponent } from '../incidents-v2-table-desktop-filters/incidents-v2-table-desktop-filters.component';

@Component({
  host: { class: 'block' },
  imports: [IncidentsV2TableComponent, IncidentsV2TableDesktopFiltersComponent],
  providers: [IncidentsCriteriaStore],
  selector: 'avs-incidents-scoped-table',
  templateUrl: './incidents-scoped-table.component.html',
})
export class IncidentsScopedTableComponent implements OnInit {
  scope = input.required<IncidentsScope>();
  columns = input.required<string[]>();
  excludedColumns = input<string[]>([]);
  dropdownFilters = input(true);
  showColumnSelect = input(true);
  isMobile = input(false);
  noDataText = input('Data is Empty');
  tableId = input('');

  protected readonly criteriaStore = inject(IncidentsCriteriaStore);
  protected readonly selectedFilters = this.criteriaStore.scopedSelectedFilters(this.scope);
  // Without a scope the table would list the whole client's incidents.
  protected readonly hasScope = computed(() => {
    const { deviceId, locationId, spaceId } = this.scope();

    return Boolean(deviceId || locationId || spaceId);
  });

  constructor() {
    this.criteriaStore.loadAvailableFiltersFor(computed(() => (this.dropdownFilters() && this.hasScope() ? this.scope() : null)));
  }

  ngOnInit() {
    this.criteriaStore.initColumns(this.columns(), this.excludedColumns());
  }

  protected onFilterCriteriaChanged(criteria: IncidentsFilterCriteria) {
    this.criteriaStore.setSelectedFilters(criteria);
  }
}
